import { createContext, useContext, ReactNode } from "react";
import { useAdminNotifications } from "@/shared/hooks/useAdminNotifications";
import type { AdminNotificationCounts } from "@/shared/types/adminNotifications.types";

type AdminNotificationsContextValue = {
  counts: AdminNotificationCounts
  isLoading: boolean
  refetch: () => void
};

const AdminNotificationsContext = createContext<AdminNotificationsContextValue | null>(null);

export const AdminNotificationsProvider = ({ children }: { children: ReactNode }) => {
  const value = useAdminNotifications();

  return (
    <AdminNotificationsContext.Provider value={value}>
      {children}
    </AdminNotificationsContext.Provider>
  );
};

export const useAdminNotificationsContext = () => {
  const context = useContext(AdminNotificationsContext);
  if (!context) {
    throw new Error("useAdminNotificationsContext must be used within AdminNotificationsProvider");
  }
  return context;
};
